import {BuildingData, Metadata, RemoteConstantsModel} from "../models/remoteConstants.model";

// Where a unit comes from in game. Players recruit a unit only from a building that
// lists it under Produceable Units (the client's BuildingOptionsModule), and a new
// unit is in no building's list — so it can sit in the tech tree and still never be
// built. A few units are left out of every list on purpose because they reach the
// map another way: a reward spawns the Giant, a passive upgrades into the Crusader.
// Those name the unit as a metadata entity, which is what tells a deliberate
// "no building" from a forgotten one.
export interface UnitSources {
    // Every building listing the unit, inactive ones included. An inactive building
    // is not in the game, so it produces nothing; it is still listed so the editor
    // can show where the unit WOULD come from.
    buildings: BuildingData[];
    // Metadata naming the unit among its entities (a reward, passive, action or
    // attribute). Only looked up when no active building produces the unit.
    grants: Metadata[];
}

export function getUnitSources(state: RemoteConstantsModel, unitId: string): UnitSources {
    const buildings = (state.buildings ?? []).filter(b => b.produceableUnits?.includes(unitId));
    if (buildings.some(b => b.active))
        return {buildings, grants: []};

    const metadata = [
        ...(state.rewards ?? []),
        ...(state.techPassiveAttributes ?? []),
        ...(state.techActionAttributes ?? []),
        ...(state.unitAttributes ?? []),
        ...(state.buildingAttributes ?? []),
    ];
    const grants = metadata.filter(m => Object.values(m.entities ?? {}).includes(unitId));
    return {buildings, grants};
}

// No active building produces the unit and nothing grants it: players have no way
// to get one.
export function isUnobtainable(sources: UnitSources): boolean {
    return !sources.buildings.some(b => b.active) && sources.grants.length === 0;
}
